@let user = userData();
@let itemLabel = label();

<div class="form-field user-date" [class.centered]="isCentered()">
    @if (itemLabel) {
        <form-label
            [id]="'user-date-label'"
            [forId]="'user-date-info'"
            [label]="itemLabel | translate"
            [minWidth]="minWidth()"></form-label>
    }

    @if (user) {
        <div class="date-info" [class.inline]="inline()" id="user-date-info">
            <date-and-time [dateTime]="user.dateTime" [dateOnly]="dateOnly()" [showTime]="showTime()"></date-and-time>
            @if (user.userId) {
                <div class="user-info">
                    by
                    <div
                        ellipsis-tooltip
                        [disableTooltip]="disableTooltip()"
                        class="user-name"
                        [id]="'user-name-' + user.userId">
                        {{ user.userName }}
                    </div>
                </div>
            }
        </div>
    } @else {
        -
    }
</div>
